import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-set-password',
  standalone: true,
  imports: [RouterModule, ReactiveFormsModule],
  templateUrl: './set-password.component.html',
  styleUrl: './set-password.component.css',
})
export class SetPasswordComponent {
  passwordForm: FormGroup = new FormGroup({
    email: new FormControl({ value: '', disabled: true }),
    password: new FormControl('', []),
    confirmPassword: new FormControl('', []),
  });

  constructor(private router: Router) {}

  setPassword(): void {
    const payload = this.passwordForm.value;
    console.log(payload);
    // TODO: call login api
  }
}
